var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 5.83203V17.4964",
    stroke: "#00A63E",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49951 14.9976C2.27854 14.9976 2.06662 14.9098 1.91037 14.7535C1.75412 14.5973 1.66634 14.3854 1.66634 14.1644V3.33317C1.66634 3.1122 1.75412 2.90028 1.91037 2.74403C2.06662 2.58778 2.27854 2.5 2.49951 2.5H6.66537C7.54925 2.5 8.39693 2.85112 9.02193 3.47612C9.64693 4.10112 9.99805 4.9488 9.99805 5.83268C9.99805 4.9488 10.3492 4.10112 10.9742 3.47612C11.5992 2.85112 12.4469 2.5 13.3307 2.5H17.4966C17.7176 2.5 17.9295 2.58778 18.0857 2.74403C18.242 2.90028 18.3298 3.1122 18.3298 3.33317V14.1644C18.3298 14.3854 18.242 14.5973 18.0857 14.7535C17.9295 14.9098 17.7176 14.9976 17.4966 14.9976H12.4976C11.8347 14.9976 11.1989 15.2609 10.7301 15.7297C10.2614 16.1984 9.99805 16.8342 9.99805 17.4971C9.99805 16.8342 9.73471 16.1984 9.26596 15.7297C8.79721 15.2609 8.16145 14.9976 7.49854 14.9976H2.49951Z",
    stroke: "#00A63E",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook2);
export default __webpack_public_path__ + "static/media/book2.714121611694a1ddc6823e2732a88dbb.svg";
export { ForwardRef as ReactComponent };